module.exports = __webpack_public_path__ + "img/404.72376b8b.png";